import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
  IOnlineHandbook, 
  OnlineHandbookResponse, 
  OnlineHandbookListResponse,
  FileUploadResponse 
} from '../models/online-handbook.model';

@Injectable({
  providedIn: 'root'
})
export class OnlineHandbookService {
  
  constructor(private http: HttpClient) {}

  // Create a new online handbook
  createOnlineHandbook(handbook: IOnlineHandbook): Observable<OnlineHandbookResponse> {
    return this.http.post<OnlineHandbookResponse>(`${environment.apiUrl}/online-handbooks/create`, handbook);
  }

  // Get all online handbooks
  getAllOnlineHandbooks(): Observable<OnlineHandbookListResponse> {
    return this.http.get<OnlineHandbookListResponse>(`${environment.apiUrl}/online-handbooks/get-all`);
  }

  // Get online handbook by ID
  getOnlineHandbookById(id: string): Observable<OnlineHandbookResponse> {
    return this.http.get<OnlineHandbookResponse>(`${environment.apiUrl}/online-handbooks/${id}`);
  }

  // Update online handbook
  updateOnlineHandbook(id: string, handbook: Partial<IOnlineHandbook>): Observable<OnlineHandbookResponse> {
    return this.http.put<OnlineHandbookResponse>(`${environment.apiUrl}/online-handbooks/${id}`, handbook);
  }

  // Delete online handbook
  deleteOnlineHandbook(id: string): Observable<OnlineHandbookResponse> {
    return this.http.delete<OnlineHandbookResponse>(`${environment.apiUrl}/online-handbooks/${id}`);
  }
} 